import { Router } from "vue-router";

import { getConsentPreferences } from "@/services/cookies/consent.service";

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
    [key: `ga-disable-${string}`]: boolean | undefined;
  }
}

const GOOGLE_ANALYTICS_SCRIPT_ID = "vaultn-google-analytics";

function getGoogleAnalyticsTrackingId(): string {
  return process.env.VUE_APP_GA_TRACKING_ID ?? "";
}

function setGoogleAnalyticsDisabled(isDisabled: boolean): void {
  const trackingId = getGoogleAnalyticsTrackingId();
  if (!trackingId) {
    return;
  }

  window[`ga-disable-${trackingId}`] = isDisabled;
}

function initializeGoogleAnalytics(): void {
  const trackingId = getGoogleAnalyticsTrackingId();
  if (!trackingId) {
    return;
  }

  window.dataLayer = window.dataLayer ?? [];
  window.gtag =
    window.gtag ??
    function gtag(...args: unknown[]) {
      window.dataLayer?.push(args);
    };

  if (!document.getElementById(GOOGLE_ANALYTICS_SCRIPT_ID)) {
    const script = document.createElement("script");
    script.async = true;
    script.id = GOOGLE_ANALYTICS_SCRIPT_ID;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
    document.head.appendChild(script);

    window.gtag("js", new Date());
  }
}

export function applyAnalyticsConsent(pagePath?: string): void {
  const trackingId = getGoogleAnalyticsTrackingId();
  if (!trackingId || !getConsentPreferences().analytics) {
    setGoogleAnalyticsDisabled(true);
    return;
  }

  setGoogleAnalyticsDisabled(false);
  initializeGoogleAnalytics();
  window.gtag?.("config", trackingId, { page_path: pagePath ?? window.location.pathname });
}

export const useAnalytics = (router: Router) => {
  router.afterEach((to) => {
    applyAnalyticsConsent(to.fullPath);
  });
};
